import React, { useEffect, useState } from "react";
import { BaseWizardProps } from "../wizard/wizard-step-base";
import { AppDispatch, RootState } from "../../state/store";
import { useDispatch, useSelector } from "react-redux";
import { WizardButtonGroup } from "../wizard/wizard-button-group-component";
import { updateCollision } from "../../state/slices/collisionSlice";
import { GoASpacer } from "@abgov/react-components";
import { Collision } from "../../models/collision";
import { isHitAndRun } from "../../state/slices/configurationSlice";
import { displaySection } from "../../common/ui-library";

interface IntroductionComponentProps extends BaseWizardProps {}

const useAppDispatch = () => useDispatch<AppDispatch>();
const useAppSelector: <TSelected>(
  selector: (state: RootState) => TSelected
) => TSelected = useSelector;

export const IntroductionComponent = ({
  navigationConfiguration,
}: IntroductionComponentProps) => {
  const dispatch = useAppDispatch();

  const stateCollision = useAppSelector((state: RootState) => state.collision);
  const stateConfiguration = useAppSelector(
    (state: RootState) => state.configuration
  );
  const [nextPage, setNextPage] = useState("");

  const [showHitAndRunText, setShowHitAndRunText] = useState(
    isHitAndRun(stateCollision.collision.collisionType ?? 0, stateConfiguration)
  );

  useEffect(() => {
    let pageConfig;

    if (
      isHitAndRun(stateCollision.collision.collisionType!, stateConfiguration)
    ) {
      pageConfig = navigationConfiguration.pagingConfiguration.find(
        (item) => item.parking !== undefined
      );

      setNextPage(pageConfig?.parking ?? "error");
    } else {
      pageConfig = navigationConfiguration.pagingConfiguration.find(
        (item) => item.default !== undefined
      );

      setNextPage(pageConfig?.default ?? "error");
    }
  }, []);

  const save = () => {
    let updatedCollision: Collision = { ...stateCollision.collision };

    if (
      navigationConfiguration.updateMetadata &&
      navigationConfiguration.stepId
    ) {
      const stepUpdated = navigationConfiguration.updateMetadata(
        updatedCollision,
        navigationConfiguration.stepId!,
        navigationConfiguration.stageCompleted
          ? navigationConfiguration.stageCompleted
          : false,
        !navigationConfiguration.stageCompleted
      );

      if (stepUpdated && updatedCollision.metadata) {
        updatedCollision.metadata = {
          ...updatedCollision.metadata,
          formState: stepUpdated,
        };
      }
    }

    dispatch(updateCollision(updatedCollision));

    if (navigationConfiguration.save) {
      navigationConfiguration.save();
    }
  };

  return (
    <div>
      <h1>Direction of travel and road details</h1>
      <GoASpacer vSpacing="l" />
      Provide additional details about your collision. Below is a summary of the
      sections that need to be completed to the best of your knowledge.
      <GoASpacer vSpacing="l" />
      <h4>Sections to fill out include:</h4>
      <ul className="goa-unordered-list">
        <div style={{ display: displaySection(!showHitAndRunText) }}>
          <li>Direction of travel</li>
        </div>
        <li>Road types</li>
        <div style={{ display: displaySection(!showHitAndRunText) }}>
          <li>Traveling lane (where applicable)</li>
        </div>
        <li>Intersections and railroad crossings</li>
        <li>Road characteristics (if applicable)</li>
      </ul>
      <WizardButtonGroup
        buttonText="Get started"
        goToReview={navigationConfiguration.goToReview}
        nextPage={nextPage}
        save={save}
        navigate={navigationConfiguration.navigate}
      />
    </div>
  );
};
